import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { PalletStockGateway } from 'src/app/application/gateway/PalletStockGateway';
import { PalletStock, PalletStockPreviewRequest, PalletStockPreviewResponse, StockColumn } from 'src/app/domain/models/PalletStock';

@Component({
  selector: 'app-pallet-stock-preview',
  templateUrl: './pallet-stock-preview.component.html',
  styleUrls: ['./pallet-stock-preview.component.css']
})
export class PalletStockPreviewComponent implements  OnInit, OnChanges {


  @Input()
  loading: boolean = false;

  ngOnInit(): void {
    this.getPreviewPalletStock()
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes['columns'] || changes['file'])
    {
      this.getPreviewPalletStock()
    }
  }

  @Input()
  file: any | undefined

  @Input()
  columns: StockColumn[] = []

  columnsPreview: StockColumn[] = []
  palletStockPreview: PalletStock[] = []

  palletStockPreviewResponse: PalletStockPreviewResponse | undefined

  constructor(
        private _router: Router,
        public translate: TranslateService,
        private _palletStockService: PalletStockGateway,
        private _messageService: MessageService,
  )
  {

  }

  getPreviewPalletStock()
  {
    this.loading = true;
    const nonEmptyColumns = this.columns.filter((el) => el.columnKey !== 'empty')

    var request: PalletStockPreviewRequest = {
      columns: nonEmptyColumns,
      file: this.file
    }

    this._palletStockService.getFormatPreview(request).subscribe({
      next: (v) => {
          this.loading = false;
          this.columnsPreview = v.columns;
          this.palletStockPreview = v.palletStock;
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.PalletStock.GetPalletPreviewError') })
      }
    })
  }


}
